import React from 'react'
import { Grid2, Typography, Box, Container, useTheme } from '@mui/material';

interface BannerProps {
    title: string;
    subtitle: string;
    image: string;
}

const WebBanner: React.FC<BannerProps> = ({ title, subtitle, image }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                background:  theme.palette.mode === "light" ? 'linear-gradient(to right, #002b80, #679cd4)' :  'linear-gradient(to right,rgb(26, 26, 27),rgb(70, 68, 68))',
                color: '#fff',
            }}
        >
            <Container maxWidth="xl">
                <Grid2 container spacing={2} alignItems="center">
                    <Grid2 size={{ xs: 12, md: 6 }} sx={{textAlign: {xs: "center", md: "start"}, paddingTop: {xs: "2rem"}}}>
                        <Typography variant="h4" component="h1" sx={{fontSize: { xs: `calc(1.25em * var(--dynamic-font-size, 1))`,md: `calc(3em * var(--dynamic-font-size, 1))`,}, fontWeight: "600" }}>
                            {title}
                        </Typography>
                        <Typography variant="subtitle1" sx={{fontSize: { xs: `calc(0.875em * var(--dynamic-font-size, 1))`,md: `calc(1.5em * var(--dynamic-font-size, 1))`,}, fontWeight: "300" }}>{subtitle}</Typography>
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 6 }} textAlign="right" sx={{textAlign: {xs: "center"}, marginTop: {xs: "1rem", md: "2rem"}, paddingTop: {xs: "1rem", md: "2rem"}}}>
                        <Box
                            component="img"
                            src={image}
                            alt="Banner"
                            sx={{height: {xs: "150px", md: "100%"}}}
                        />
                    </Grid2>
                </Grid2>
            </Container>
        </Box>
    )
}

export default WebBanner